// extracted by mini-css-extract-plugin
export default {"container":"style_container__CLBbs","titleSection":"style_titleSection__8oUJ3"};